import React from "react";
import PropTypes from "prop-types";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { buildSurveyVisualChoiceStylesheet } from "../elements/ElementSurveyStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";
library.add(fab, fas, far);

const FieldOptionVisualChoice = (props) => {
  let field_option = props.field_option;
  let field = props.field;
  let important = props.builder !== true ? " !important" : "";
  let element = props.element;
  let variant = props.variant;
  const classes = style.classes(element, props.device);
  const stylesheet = buildSurveyVisualChoiceStylesheet(
    props.builder,
    props.device,
    props.cta,
    element,
    variant,
    field_option
  );

  const isImageVisualType = () => {
    return (
      (field_option.visual_type === null &&
        field_option.image &&
        field_option.image !== "none") ||
      (field_option.visual_type === "image" && field_option.image !== "none")
    );
  };

  const isLetterVisualType = () => {
    return field_option.visual_type === "letter" && field_option.letter;
  };

  const isIconVisualType = () => {
    return field_option.visual_type === "icon" && field_option.icon;
  };

  const isEmojiVisualType = () => {
    return field_option.visual_type === "emoji" && field_option.emoji;
  };

  const isColorVisualType = () => {
    return field_option.visual_type === "color";
  };

  const visualTypePlacement = () => {
    if (props.device == "mobile") {
      return (
        element.options["visual-type-placement-mobile"] ||
        variant.options["visual-type-placement-mobile"]
      );
    } else {
      return (
        element.options["visual-type-placement"] ||
        variant.options["visual-type-placement"]
      );
    }
  };

  const fieldLabel = field_option.value
    ? field_option.value
    : field_option.label
    ? field_option.label
    : "Option " + field_option.position

  return (
    <React.Fragment>
      <div
        data-id={field_option.id}
        data-field-option-id={field_option.id}
        data-position={field_option.position}
        data-value={fieldLabel}
        className={classes}
        role="button"
        tabIndex="0"
        aria-label={fieldLabel}
      >
        <div
          className="cf-col-xs-12 cf-survey-choice-label"
          style={{
            textAlign: "inherit" + important,
          }}
        >
          <div
            className="cf-visual-type-outer-box"
            style={{
              fontFamily: element.options["field-font"]
                ? element.options["field-font"] + important
                : undefined,
            }}
          >
            {isImageVisualType() ||
            isLetterVisualType() ||
            isIconVisualType() ||
            isColorVisualType() ||
            isEmojiVisualType() ? (
              <div className="cf-visual-type-box">
                {/* BEGIN IMAGE VISUAL TYPE */}
                {isImageVisualType() ? (
                  <span
                    className={
                      "cf-visual-type cf-row cf-outer-center cf-survey-choice-image-container"
                    }
                    style={{
                      display:
                        visualTypePlacement() == "centered"
                          ? "block"
                          : "inline-block",
                    }}
                  >
                    <img src={field_option.image}></img>
                  </span>
                ) : (
                  ""
                )}
                {/* END IMAGE VISUAL TYPE */}

                {/* BEGIN LETTER VISUAL TYPE */}
                {isLetterVisualType() ? (
                  <span className="cf-visual-type-letter">
                    {field_option.letter}
                  </span>
                ) : (
                  ""
                )}
                {/* END LETTER VISUAL TYPE */}

                {/* BEGIN ICON VISUAL TYPE */}
                {isIconVisualType() ? (
                  <span className="cf-visual-type">
                    <FontAwesomeIcon icon={field_option.icon} />
                  </span>
                ) : (
                  ""
                )}
                {/* END ICON VISUAL TYPE */}

                {/* BEGIN EMOJI VISUAL TYPE */}
                {isEmojiVisualType() ? (
                  <span className="cf-visual-type">{field_option.emoji}</span>
                ) : (
                  ""
                )}
                {/* END EMOJI VISUAL TYPE */}

                {/* BEGIN COLOR VISUAL TYPE */}
                {isColorVisualType() ? (
                  <span className="cf-visual-type-color" />
                ) : (
                  ""
                )}
                {/* END COLOR VISUAL TYPE */}
              </div>
            ) : (
              ""
            )}

            <div
              className="cf-survey-label"
              dangerouslySetInnerHTML={{
                __html: field_option.label
                  ? field_option.label
                  : field_option.value &&
                    !field_option.visual_type &&
                    (!field_option.image || field_option.image == "none")
                  ? field_option.value
                  : !field_option.visual_type &&
                    (!field_option.image || field_option.image == "none")
                  ? "Option " + field_option.position
                  : "",
              }}
            ></div>
          </div>
        </div>
        <BuilderStyleTag
          builder={props.builder}
          styleKey={`cta:${props.cta.id}:element:${element.id}:field-option:${field_option.id}:survey-visual-choice`}
          stylesheet={stylesheet}
        />
      </div>
    </React.Fragment>
  );
};

const style = {
  classes: (element, device) => {
    let options = element.options;
    let classes = "cf-survey-choice";

    let optionsWidthClass = "";
    if (options["options-width"] && options["options-width"] !== "custom") {
      optionsWidthClass = options["options-width"];
    }

    if (device == "mobile") {
      if (options["options-width-mobile"] && options["options-width-mobile"] !== "custom") {
        optionsWidthClass = options["options-width-mobile"];
      }
    }
    classes += " " + optionsWidthClass;

    classes += " " + (options["button-radius"] ? options["button-radius"] : "");

    classes += " " + (options["button-size"] ? options["button-size"] : "");

    return classes;
  },
};

export default FieldOptionVisualChoice;
